import React, { memo, useEffect, useState } from "react";
import { isEmpty, sortBy, findKey } from "lodash";
import { Grid, Typography, RadioGroup, FormControl } from "@mui/material";
import qs from "qs";
import ButtonRight from "../../components/BoxRightContent/ButtonRight";
import BoxLeftContent from "../../components/BoxLeftContent/BoxLeftContent";
import Configs from "../../constants/Configs";
import DialogError from "../../components/CustomDialog/DialogWait";
import {
  getData,
  storeData,
  clearData,
  getAllStorage,
  callChoice,
} from "../../utils/GlobalHelper";
import HeaderRight from "../../components/BoxRightContent/HeaderRight";
import HeaderPage from "../../components/HeaderPage/Index";
import { isMobile } from "react-device-detect";
import Loading from "../../components/loading/loading";
import { Wrapper, CardList } from "../../components/NDID2";
import ScrollBarComponent from "../../components/BoxRightContent/ScrollBarComponent";
import GlobalApi from "../../utils/GlobalApi";
import DialogCustoms from "../../components/CustomDialog/DialogCustoms";
import ThaID_ICON from "../../assets/image/ThaID2.png";
const EkycList = (props) => {
  const [valueModal, setValueModal] = useState({
    isMax: false,
    imgError: true,
    imgSuccess: false,
    title: "ท่านสามารถเปลี่ยนธนาคารได้ 3 ครั้ง",
    massage: "กรุณาตรวจสอบที่แอปพลิเคชันของธนาคารก่อน ยืนยันการเปลี่ยนธนาคาร",
    btnPrimary: "ดำเนินการต่อที่",
    btnSecondary: "ยืนยันการเปลี่ยนธนาคาร",
  });
  const [isModal, setIsModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalError, setIsModalError] = useState(false);
  const [lang, setLang] = useState(getData("lang"));
  const [modalErrorTitle, setModalErrorTitle] = useState("เกิดข้อผิดพลาด");
  const [modalErrorDes, setModalErrorDes] = useState(
    "ไม่สามารถทำรายการได้ในขณะนี้<br/>กรุณาทำรายการใหม่สอบถามข้อมูลเพิ่มเติม<br/>กรุณาติดต่อ DAOL Contact Center<br/>0 2351 1800",
  );
  const [dataList, setDataList] = useState([]);
  const [value, setValue] = useState("");
  const translations = getData("Translations");
  const head_token = getData("HeaderManp")
    ? getData("HeaderManp")?.head_token
    : "";

  const idc = getData("idc");
  const header = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Accept: "application/json",
    },
  };
  const [jumpPage, setJumpPage] = useState(false);
  const checkuserinfo = getData("checkuserinfo");
  const questions = getData("questionsAnswer");
  const pageAgree = getData("page_agree");
  const idcAddr = getData("f2_idc_address");
  const curAddr = getData("f2_current_address");
  const workAddr = getData("f2_workplace_address");
  const docAddr = getData("f2_document_address");
  const suit = getData("suitability");
  const status = getData("family_status");
  const childList = getData("childList");
  const career = getData("f3_career");
  const income = getData("f3_source_income");
  const purpose = getData("f3_purpose_invest");
  const asset = getData("f3_asset");
  const ats = getData("f7_ats");
  const bank_ats = getData("f7_bank_ats");
  let snapIdCard = getData("uploadImage");
  let uploadImgSign = getData("uploadImageSign");
  let uploadImageBookBank = getData("uploadImageBookBank");

  const checkJumpPage = async () => {
    var stamp_page = getData("stamp_page");
    console.log("==stamp_page", stamp_page);
    await getImage();
    let productChoice = false;
    await callChoice(head_token).then((res) => {
      if (!isEmpty(res)) {
        res.forEach((e) => {
          e.items.forEach((item) => {
            if (item.selected === 1) productChoice = true;
          });
        });
      }
    });
    console.log("00", pageAgree);

    if (
      isEmpty(checkuserinfo) ||
      isEmpty(questions) ||
      isEmpty(pageAgree) ||
      pageAgree.termandcon !== 1 ||
      pageAgree.pdpa !== 1 ||
      isEmpty(snapIdCard) ||
      isEmpty(idc) ||
      isEmpty(idcAddr) ||
      isEmpty(curAddr) ||
      isEmpty(workAddr) ||
      isEmpty(docAddr) ||
      isEmpty(career) ||
      !productChoice ||
      isEmpty(suit) ||
      isEmpty(status) ||
      isEmpty(childList?.data) ||
      isEmpty(income) ||
      isEmpty(purpose) ||
      isEmpty(asset) ||
      isEmpty(uploadImgSign) ||
      isEmpty(ats) ||
      isEmpty(bank_ats) ||
      (isEmpty(uploadImageBookBank) && ats.f7_isother === "1") ||
      (stamp_page !== "EKYC" && stamp_page !== "SUMMARY")
    ) {
      return true;
    } else {
      return false;
    }
  };
  const getImage = async () => {
    setIsLoading(true);
    var postData = {
      head_token,
    };
    const header = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const queryString = new URLSearchParams(postData).toString();
    let getImage_url = `${Configs.baseAPIURL01}/api/getupload?` + queryString;
    try {
      await GlobalApi.get(getImage_url, header)
        .then(async (res) => {
          setIsLoading(false);
          if (res.data.api_status === "1") {
            if (res.data.data.length > 0) {
              res.data.data.forEach((element) => {
                if (element.tb_image_page === "uploadImage") {
                  snapIdCard = element.tb_image_type + element.tb_image_base64;
                } else if (element.tb_image_page === "eSignature") {
                  uploadImgSign =
                    element.tb_image_type + element.tb_image_base64;
                } else if (element.tb_image_page === "eSignature") {
                  uploadImgSign =
                    element.tb_image_type + element.tb_image_base64;
                } else if (element.tb_image_page === "uploadImageBookBank") {
                  uploadImageBookBank =
                    element.tb_image_type + element.tb_image_base64;
                }
              });
            }
          }
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
    return;
  };
  const getVerifyMaster = async () => {
    try {
      setIsLoading(true);
      clearData("bank_id");
      const passNDID = getData("pass_ndid");
      const passDIPCHIP = getData("pass_dipchip");
      if (passNDID || passDIPCHIP) {
        // setIsLoading(false);
        storeData("stamp_page", "CONFIRM");
        var last_stamp = JSON.stringify(await getAllStorage("CONFIRM"));
        const saveData = [
          {
            name: "comeback",
            url: `${Configs.baseAPIURL03}/form/comeback/manp`,
            postData: {
              head_token: head_token,
              last_stamp: last_stamp,
              stamp_page: "CONFIRM",
            },
          },
        ];
        setIsLoading(true);
        try {
          await GlobalApi.post(
            saveData[0].url,
            qs.stringify(saveData[0].postData),
            header,
          )
            .then((res) => {
              setIsLoading(false);
              if (res?.data?.Data?.[0]?.[0]?.IsSuccess !== 1) {
                let mss =
                  res.data.Data[0].MsgDesc !== ""
                    ? res.data.Data[0].MsgDesc
                    : "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";
                let title = "เกิดข้อผิดพลาด";
                setIsLoading(false);
                setIsModalError(true);
                setModalErrorTitle(title);
                setModalErrorDes(mss);
              } else {
                // console.log("save" + saveData[0].name + "  success");
                props.history.push("/products_consent");
              }
            })
            .catch((er) => {
              // console.log(er);
              // console.log("save " + saveData[0].name + "  error");
              setIsLoading(false);
              let title = "เกิดข้อผิดพลาด";
              let mss =
                "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" +
                getData("api_error")?.message +
                ")";
              setIsModalError(true);
              setModalErrorTitle(title);
              setModalErrorDes(mss);
            });
        } catch (error) {
          // console.log(error);
          // console.log("catch" + saveData[0].name + "  error");
          setIsLoading(false);
          setIsModalError(true);
        }
      } else {
        await GlobalApi.get(
          `${Configs.baseAPIURL03}/constant/ekyc_channel?personflag=${"T"}`,
        )
          .then((res) => {
            console.log(idc);
            console.log(res.data?.Data);
            setIsLoading(false);
            setSort(res.data?.Data);

            if (res.data?.Data?.length === 0) {
              title_mss = "เกิดข้อผิดพลาด";
              mss =
                "ไม่สามารถทำรายการได้ในขณะนี้<br/>กรุณาทำรายการใหม่สอบถามข้อมูลเพิ่มเติม<br/>กรุณาติดต่อ DAOL Contact Center<br/>0 2351 1800";
              setModalErrorTitle(title_mss);
              setModalErrorDes(mss);
              setIsModalError(true);
            }
          })
          .catch((error) => {
            setIsLoading(false);
            var mss = "";
            var title_mss = "";
            if (!!error.isAxiosError && !error.response) {
              title_mss = "เกิดข้อผิดพลาด";
              mss =
                "ไม่สามารถทำรายการได้ในขณะนี้<br/>กรุณาทำรายการใหม่สอบถามข้อมูลเพิ่มเติม<br/>กรุณาติดต่อ DAOL Contact Center<br/>0 2351 1800";
            } else {
              title_mss =
                error.response.data.Data !== undefined &&
                error.response.data.Data[0][0].MsgDescTitle !== ""
                  ? error.response.data.Data[0][0].MsgDescTitle
                  : "เกิดข้อผิดพลาด";
              mss =
                error.response.data.Data !== undefined &&
                error.response.data.Data[0][0].MsgDesc !== ""
                  ? error.response.data.Data[0][0].MsgDesc
                  : "ไม่สามารถทำรายการได้ในขณะนี้<br/>กรุณาทำรายการใหม่สอบถามข้อมูลเพิ่มเติม<br/>กรุณาติดต่อ DAOL Contact Center<br/>0 2351 1800";
            }
            setModalErrorTitle(title_mss);
            setModalErrorDes(mss);
            setIsModalError(true);
          });
      }
    } catch (error) {
      setIsLoading(false);
      setIsModalError(true);
    }
  };
  const handleNext = async () => {
    sendData();
  };
  const sendData = () => {
    if (value === "NDID") {
      saveComeback("NDID");
    } else if (value === "DIPCHIP") {
      saveComeback("DIPCHIP");
    } else if (value === "ThaID") {
      saveComeback("ThaID");
    }
  };
  //Call API: Save Comeback when Edit
  const saveComeback = async (type) => {
    storeData("stamp_page", type);
    var last_stamp = JSON.stringify(await getAllStorage(type));
    const saveData = [
      {
        name: "comeback",
        url: `${Configs.baseAPIURL03}/form/comeback/manp`,
        postData: {
          head_token: head_token,
          last_stamp: last_stamp,
          stamp_page: type,
        },
      },
    ];
    setIsLoading(true);
    try {
      await GlobalApi.post(
        saveData[0].url,
        qs.stringify(saveData[0].postData),
        header,
      )
        .then((res) => {
          setIsLoading(false);
          if (res?.data?.Data?.[0]?.[0]?.IsSuccess !== 1) {
            let mss =
              res.data.Data[0].MsgDesc !== ""
                ? res.data.Data[0].MsgDesc
                : "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";
            let title = "เกิดข้อผิดพลาด";
            setIsLoading(false);
            setIsModalError(true);
            setModalErrorTitle(title);
            setModalErrorDes(mss);
          } else {
            switch (type) {
              case "NDID":
                props.history.push("/ndid_information");
                break;
              case "EKYC":
                props.history.push("/ekyc");
                break;
              case "DIPCHIP":
                props.history.push("/dipchip_waiting");
                break;
              case "ThaID":
                props.history.push("/thaid_condition");
                break;
              default:
                props.history.push("/products_consent");
            }
          }
        })
        .catch((er) => {
          setIsLoading(false);
          let title = "เกิดข้อผิดพลาด";
          let mss =
            "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" +
            getData("api_error")?.message +
            ")";
          setIsModalError(true);
          setModalErrorTitle(title);
          setModalErrorDes(mss);
        });
    } catch (error) {
      setIsLoading(false);
      setIsModalError(true);
    }
  };

  useEffect(() => {
    checkJumpPage().then(async (res) => {
      if (res) {
        setJumpPage(true);
      } else {
        if (value === "ThaID") {
          const img = `<img src="${ThaID_ICON}" alt="เปิดแอป ThaID" style="width: 50px; border-radius: 8px;"/>`;
          let massage = `<span>กรุณาตรวจสอบให้แน่ใจว่าท่านดำเนินการ<br> “ติดตั้งและลงทะเบียนแอปพลิเคชัน ThaID” <br>เรียบร้อยแล้ว</span> <p style="background-color: rgb(247, 248, 251);padding: 10px;margin:10px"><span className="font-DBHeavent font-18">ดาวน์โหลดแอปพลิเคชัน ThaID ได้ที่ <br/><a href="https://www.bora.dopa.go.th/app-ThaID/" target="_blank"rel="noopener noreferrer">${img}</a></span></p>`;
          setValueModal({
            imgError: true,
            imgSuccess: false,
            title: "คำแนะนำ",
            massage: massage,
            btnPrimary: "ตกลง",
          });
          setIsModal(true);
        }
        getVerifyMaster();
      }
    });
  }, [value]);
  const popUps = async (val, statusError, statusSuccess) => {
    // val -> True is primary button : False is secondary button
    console.log(" popUps");
    console.log(val);
    console.log(statusError);
    console.log(statusSuccess);

    if (statusSuccess) {
    }
  };
  const transformBankData = (key) => (banks) => {
    const sortedData = sortBy(banks, key);
    return sortedData.map((verification) => ({
      value: verification.verification_Code,
      logo: verification.verification_logo,
      name: verification[key],
      appName: verification.verification_En,
    }));
  };

  const setSort = (data) => {
    const ORDER = ["DIPCHIP", "THAID", "NDID"];

    const key = lang === "th" ? "verification_Th" : "verification_En";
    const current_ic = getData("current_ic");
    const transformWithKey = transformBankData(key);
    const filteredMethods = !current_ic?.AECode
      ? transformWithKey(data).filter((item) => item.value !== "DIPCHIP")
      : transformWithKey(data);

    const sorted = filteredMethods.sort(
      (a, b) => ORDER.indexOf(a.value) - ORDER.indexOf(b.value),
    );

    setDataList(sorted);
  };
  return (
    <>
      {jumpPage ? (
        <Grid className="app-splash-screen"></Grid>
      ) : (
        <>
          <HeaderPage
            title={translations?.[lang]?.verify?.title}
            onChangeLang={(e) => setLang(e)}
            clickBack={(e) => (e ? props.history.push("/summary") : "")}
          />
          <Loading status={isLoading} />
          <DialogError
            open={isModalError}
            isModel={setIsModalError}
            title={modalErrorTitle}
            massageDes={modalErrorDes}
            btn={"ตกลง"}
          />
          <DialogCustoms
            open={isModal}
            isModel={setIsModal}
            imgModalError={valueModal.imgError}
            imgModalSuccess={valueModal.imgSuccess}
            switchType={(e) => {
              popUps(e, valueModal.imgError, valueModal.imgSuccess);
            }}
            title={valueModal.title}
            massageDes={valueModal.massage}
            btnPrimary={valueModal.btnPrimary}
            btnSecondary={valueModal.btnSecondary}
          />
          <Grid className="background-bg">
            <Grid className="section-consent">
              <Grid className={isMobile ? "box-content-mb" : "box-content"}>
                <Grid container className="box-content-main" columns={16}>
                  {!isMobile && (
                    <Grid item xs={7} className="box-left">
                      <BoxLeftContent
                        translations={translations?.[lang]?.verify}
                        clickBack={(e) => props.history.push("/summary")}
                      />
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={isMobile ? 16 : 9}
                    className={isMobile ? "box-right-mb" : "box-right"}
                  >
                    <Grid className="content">
                      <Grid
                        className="box-right-content pb-3"
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          height: "100%",
                           px: 2,
                        }}
                      >
                        {!isMobile && (
                          <HeaderRight
                            title={translations?.[lang]?.verify?.title}
                          />
                        )}
                      
                            <ScrollBarComponent
                              content={
                                <Grid
                                  id="banks"
                                  container
                                  style={{ justifyContent: "center" }}
                                >
                                  <FormControl>
                                    <RadioGroup
                                      name="bank-list"
                                      value={value}
                                      onChange={(e) => setValue(e.target.value)}
                                    >
                                      <CardList
                                        // label={"เลือกช่องทางการยืนยันตัวตน"}
                                        data={dataList}
                                        labelStyle={"0px"}
                                      />
                                    </RadioGroup>
                                  </FormControl>
                                </Grid>
                              }
                            />
                          
                        <ButtonRight
                          isDisbled
                          disbled={!!value}
                          text={translations?.[lang]?.verify?.next}
                          onNextPage={handleNext}
                          // btnStyle={{
                          //   transform: "unset",
                          //   top: "0",
                          //   height: "47px !important",
                          // }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

export default memo(EkycList);
